import { render, staticRenderFns } from "./EvaluationModal.vue?vue&type=template&id=63d53e2c&scoped=true"
import script from "./EvaluationModal.vue?vue&type=script&lang=js"
export * from "./EvaluationModal.vue?vue&type=script&lang=js"
import style0 from "./EvaluationModal.vue?vue&type=style&index=0&id=63d53e2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d53e2c",
  null
  
)

export default component.exports